var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.5C1.34531 0.5 0 1.84531 0 3.5V18.5C0 20.1547 1.34531 21.5 3 21.5H18C19.6547 21.5 21 20.1547 21 18.5V3.5C21 1.84531 19.6547 0.5 18 0.5H3ZM16.9266 4.4375L12.0609 9.99688L17.7844 17.5625H13.3031L9.79688 12.9734L5.77969 17.5625H3.55313L8.75625 11.6141L3.26719 4.4375H7.86094L11.0344 8.63281L14.7 4.4375H16.9266ZM15.1547 16.2313L7.19062 5.69844H5.86406L13.9172 16.2313H15.15H15.1547Z",
    fill: "#395BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.d7f6dff593c417b4aa4f1636672e2940.svg";
export { ForwardRef as ReactComponent };